<template>
  <div class="h-100">
    <GoogleMapStatic
      :apikey="apikey"
      :zoomlevel="zoomlevel"
      :center="vendor"
      :markers="markers"
      :mapstyle="mapstyle"
    />
    <ParkingSpacesList
      v-open-modal="'parkingSpaceModal'"
      :city-zone-id="cityZoneId"
      :distance-point="vendor"
      :t="t"
      :limit="1"
      class="list"
    />
  </div>
</template>

<script>
import GoogleMapStatic from "./GoogleMapStatic";
import ParkingSpacesList from "./ParkingSpaceList";
import { mapGetters } from "vuex";

export default {
  name: "GoogleMapStaticParkingWrapper",
  components: { GoogleMapStatic, ParkingSpacesList },
  props: {
    vendor: {
      type: Object,
      required: true,
    },
    cityZoneId: {
      type: String,
      required: true,
    },
    zoomlevel: {
      type: String,
      required: true,
    },
    apikey: {
      type: String,
      required: true,
    },
    vendorMarkerUrl: {
      type: String,
      required: true,
    },
    mapstyle: {
      type: String,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ parkingSpaces: "parkingSpaces/parkingSpacesDistance" }),
    markers() {
      return this.parkingSpaces(this.vendor).reduce(
        (markers, parkingSpace) => {
          markers.push({
            color: "blue",
            location: { lat: parkingSpace.lat, lng: parkingSpace.lng },
          });
          return markers;
        },
        [{ scale: 2, icon: this.vendorMarkerUrl, location: this.vendor }]
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.list {
  position: absolute;
  bottom: -1px; // safety offset because of browser renderung (jan)
  background: $white;
  border-top-left-radius: $border-radius-lg;
  border-top-right-radius: $border-radius-lg;
  box-shadow: $box-shadow-lg;
  left: $spacer-2;
  right: $spacer-2;
  padding: 0 $spacer-2;
}
</style>
